export const fmtCurrency = (n) =>
  new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

// Always shows cents — used anywhere a cent-level difference actually matters
// (contract rent, payments), since fmtCurrency's rounding to whole euros can
// make two genuinely different amounts look identical.
export const fmtCurrencyExact = (n) =>
  new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);

export const fmtPct = (n) => `${(n || 0).toFixed(2)}%`;

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString();
  } catch {
    return s;
  }
};
